/**
 * @fileoverview Input/output schemas for chapter-architect-remaining-v2.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { ChapterIdeaSchema } from '@/domains/chapter-workspace/schemas';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 */
export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.seriesContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characterRoles.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.projectedTotalChapters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.chapterMetadata.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
});

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

// Uses same output schema as chapter-architect-v2
export const OutputSchema = z.object({
  chapters: z.array(ChapterIdeaSchema).describe('An array of all generated chapters for the story.'),
  explanation: z.string().describe('A brief explanation of the main choices made while generating the chapters outlines.'),
});

export type Output = z.infer<typeof OutputSchema>;
